import { privateApi } from 'services';
import { JobVacancyTargetingLocation } from './types';

const fetchJobVacancyTargetingLocations = async (JobVacancyId: string): Promise<JobVacancyTargetingLocation[]> =>
    privateApi.get(`job-vacancies/${JobVacancyId}/targeting-locations`);

export const JobVacancyTargetingLocationGateway = {
    fetchJobVacancyTargetingLocations,
};
